import { Popconfirm, Tooltip, Select } from "antd";
import React, { Component } from "react";
import axios from "axios";
import {
  ButtonItem,
  SegmentedItem,
  TableItemDinamico,
  dineroDisabledMask,
} from "../../../../Components/Items";
import { connect } from "react-redux";
import {
  StopOutlined,
  EditOutlined,
  CheckCircleOutlined,
  ImportOutlined,
  FilePdfOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import ListaEscuelaModal from "../ListaEscuelaModal/ListaEscuelaModal";
import ModalPdfLista from "../ModalPdfLista/ModalPdfLista";

class ListasTab extends Component {
  tableRef = null;
  state = {
    todasListas: [],
    loading: false,
    valor: 1,
    totalRecords: 0,
    modalVisible: false,
    listaSeleccionada: null,
    modalPdfVisible: false,
    listaPdfId: null,
    listaPdfNombre: "",
    empresaPrecios: [],
    nivelPrecioId: null,
  };

  componentDidMount() {
    this.cargarNivelesPrecio();
  }

  cargarNivelesPrecio = () => {
    axios
      .post(
        "listasEscuela/empresaPreciosParaPdfLista",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) return;
        const precios = res.data.empresaPrecios || [];
        const preciosOnlineId = res.data.preciosOnlineId
          ? String(res.data.preciosOnlineId)
          : null;
        // Default: precio del ecommerce (si existe en la lista) → primer precio.
        const existeOnline = precios.some(
          (p) => String(p._id) === preciosOnlineId
        );
        const defaultNivel = existeOnline
          ? preciosOnlineId
          : precios.length > 0
          ? String(precios[0]._id)
          : null;
        this.setState({ empresaPrecios: precios, nivelPrecioId: defaultNivel });
      });
  };

  consultarListas = (params) => {
    this.setState({ loading: true });
    axios
      .post(
        "listasEscuela/selectTodasListasEscuela",
        { empresaId: this.props.empresaId, ...params },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todasListas: res.data.data,
            totalRecords: res.data.totalRecords || 0,
            loading: false,
          });
        } else {
          this.setState({ todasListas: [], totalRecords: 0, loading: false });
        }
      });
  };

  abrirAgregar = () => {
    this.setState({ modalVisible: true, listaSeleccionada: null });
  };
  abrirEditar = (lista) => {
    this.setState({ modalVisible: true, listaSeleccionada: lista });
  };
  cerrarModal = (recargar = false) => {
    this.setState({ modalVisible: false, listaSeleccionada: null });
    if (recargar) this.recargarTabla();
  };

  // updateExternalFilters reemplaza el objeto completo, por lo que siempre
  // hay que reenviar todos los filtros externos (valor + nivelPrecioId).
  recargarTabla = (overrides = {}) => {
    if (!this.tableRef) return;
    this.tableRef.updateExternalFilters({
      valor: this.state.valor,
      nivelPrecioId: this.state.nivelPrecioId,
      ...overrides,
    });
  };

  abrirPdfLista = (lista) => {
    this.setState({
      modalPdfVisible: true,
      listaPdfId: lista._id,
      listaPdfNombre: lista.nombre || "",
    });
  };
  cerrarPdfLista = () => {
    this.setState({
      modalPdfVisible: false,
      listaPdfId: null,
      listaPdfNombre: "",
    });
  };

  cambiarEstado = (id, deshabilitar) => {
    const url = deshabilitar
      ? "listasEscuela/deshabilitarListaEscuela"
      : "listasEscuela/habilitarListaEscuela";
    axios
      .post(url, { listaId: id }, { headers: this.props.headersToken })
      .then(() => {
        this.recargarTabla();
      });
  };

  render() {
    const columns = [
      { title: "Nombre", dataIndex: "nombre", key: "nombre", sorter: true, buscar: "nombre" },
      {
        title: "Insumos",
        dataIndex: "cantidadInsumos",
        key: "cantidadInsumos",
        align: "center",
        width: "15%",
      },
      {
        title: "Costo Total",
        dataIndex: "costoTotal",
        key: "costoTotal",
        align: "right",
        width: "20%",
        render: (v) => dineroDisabledMask(Number(v || 0)),
      },
      {
        title: "Precio al Público",
        dataIndex: "precioTotal",
        key: "precioTotal",
        align: "right",
        width: "20%",
        render: (v) => dineroDisabledMask(Number(v || 0)),
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "15%",
        onCell: () => ({ className: "acciones-sin-hover", style: { textAlign: "center", padding: "4px" } }),
        render: (value, record) => (
          <div className="acciones-container">
            <Tooltip title={this.props.permisoVerEnviarPdfLista ? "Ver / Enviar PDF" : "No disponible"}>
              <ButtonItem
                size="small"
                naranja
                icon={<FilePdfOutlined />}
                disabled={!this.props.permisoVerEnviarPdfLista}
                onClick={() => this.props.permisoVerEnviarPdfLista && this.abrirPdfLista(record)}
              />
            </Tooltip>
            <Tooltip title={this.props.permisoEditarLista ? "Editar Lista" : "No disponible"}>
              <ButtonItem
                size="small"
                cyan
                icon={<EditOutlined />}
                disabled={!this.props.permisoEditarLista}
                onClick={() => this.props.permisoEditarLista && this.abrirEditar(record)}
              />
            </Tooltip>
            {value.estado === 1 ? (
              <Popconfirm
                title="¿Deshabilitar esta lista?"
                onConfirm={() => this.cambiarEstado(value._id, true)}
                okText="Si"
                cancelText="No"
                disabled={!this.props.permisoDeshabilitarLista}
              >
                <Tooltip title={this.props.permisoDeshabilitarLista ? "Deshabilitar" : "No disponible"}>
                  <ButtonItem size="small" lima icon={<CheckCircleOutlined />} disabled={!this.props.permisoDeshabilitarLista} />
                </Tooltip>
              </Popconfirm>
            ) : (
              <Popconfirm
                title="¿Habilitar esta lista?"
                onConfirm={() => this.cambiarEstado(value._id, false)}
                okText="Si"
                cancelText="No"
                disabled={!this.props.permisoDeshabilitarLista}
              >
                <Tooltip title={this.props.permisoDeshabilitarLista ? "Habilitar" : "No disponible"}>
                  <ButtonItem size="small" rojo icon={<StopOutlined />} disabled={!this.props.permisoDeshabilitarLista} />
                </Tooltip>
              </Popconfirm>
            )}
          </div>
        ),
      },
    ];

    return (
      <>
        <div
          style={{
            display: "flex",
            gap: 8,
            alignItems: "center",
            justifyContent: "flex-end",
            marginBottom: 10,
          }}
        >
          {this.state.empresaPrecios.length > 0 && (
            <Select
              value={this.state.nivelPrecioId}
              onChange={(v) => {
                this.setState({ nivelPrecioId: v });
                this.recargarTabla({ nivelPrecioId: v });
              }}
              style={{ width: 220 }}
              placeholder="Lista de precios"
            >
              {this.state.empresaPrecios.map((p) => (
                <Select.Option key={String(p._id)} value={String(p._id)}>
                  {p.nombre}
                </Select.Option>
              ))}
            </Select>
          )}
          <SegmentedItem
            options={[
              { label: "Activo", value: 1 },
              { label: "Deshabilitado", value: 2 },
              { label: "Todos", value: 3 },
            ]}
            onChange={(value) => {
              this.setState({ valor: value });
              this.recargarTabla({ valor: value });
            }}
            value={this.state.valor}
          />
          {this.props.permisoListasExportarImportarAgregar && (
            <>
              <ButtonItem
                type="default"
                className="botonAgregar"
                icon={<FileExcelOutlined />}
                onClick={() => this.props.history.push("/panel/exportarListas")}
              >
                Exportar Listas
              </ButtonItem>
              <ButtonItem
                type="default"
                className="botonAgregar"
                icon={<ImportOutlined />}
                onClick={() => this.props.history.push("/panel/importarListas")}
              >
                Importar Listas
              </ButtonItem>
              <ButtonItem
                type="primary"
                olivo
                className="botonAgregar"
                onClick={this.abrirAgregar}
              >
                Agregar Lista
              </ButtonItem>
            </>
          )}
        </div>

        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarListas}
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasListas}
          columns={columns}
          onRow={(record) => ({
            onDoubleClick: () =>
              this.props.permisoEditarLista && this.abrirEditar(record),
          })}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
          filterStorageKey={"listasEscuelaFiltrosTabla" + this.props.empresaId}
        />

        <ListaEscuelaModal
          visible={this.state.modalVisible}
          lista={this.state.listaSeleccionada}
          cerrarModal={this.cerrarModal}
        />

        <ModalPdfLista
          visible={this.state.modalPdfVisible}
          listaId={this.state.listaPdfId}
          nombreLista={this.state.listaPdfNombre}
          onCancel={this.cerrarPdfLista}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoListasExportarImportarAgregar:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3c3089586391440574a9"
    )?.activado,
  permisoVerEnviarPdfLista:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3c6489586391440574b9"
    )?.activado,
  permisoEditarLista:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3c7e89586391440574c0"
    )?.activado,
  permisoDeshabilitarLista:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "6a1e3c9989586391440574c7"
    )?.activado,
});

export default connect(mapStateToProps)(ListasTab);
